import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { PayoutAccountType, PayoutAccountTypeEnum, WalletDetail } from 'app/models';

@Component({
    selector: 'partner-payout-account-details',
    templateUrl: './partner-payout-account-details.component.html',
    styleUrls: ['./partner-payout-account-details.component.scss']
})

export class PartnerPayoutAccountDetailsComponent {
    constructor(private messageService: MessageService) { }

    @Input()
    public showMerchantDetailPaymentSideBar: boolean = false;

    @Input()
    public payment: any;

    @Input()
    public onHide: () => void = () => { };

    public payoutAccountTypes = PayoutAccountType.PayoutAccountTypeList;
    public walletDetails = WalletDetail.WalletDetailList;

    public payoutAccountTypeEnum = PayoutAccountTypeEnum;
    public cancel() {
        this.onHide();
    }
}
